import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import "@/i18n";
import i18next from "@/i18n";
import "@/index.css";
import { getUserLanguage } from "@/utils/utils.util.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App.tsx";

function setLanguage() {
  const lsLang = getUserLanguage();
  i18next.changeLanguage(lsLang);
}

setLanguage();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    {/* <SocketProvider> */}
    <StrictMode>
      <App />
    </StrictMode>
    {/* </SocketProvider> */}
  </ErrorBoundary>
);
